/**
 * FX HedgePool Inc. Proprietary and Confidential
 *
 * This source code and the algorithms implemented herein are the sole property of FX HedgePool, Inc.,
 * are confidential information, and are trade secrets of FX HedgePool, Inc.
 * Redistribution or use of this source code or the algorithms implemented herein, in whole or in part,
 * without the express written permission of FX HedgePool, Inc. is strictly prohibited.
 */

import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, filter, switchMap, tap } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { User } from '../models/user';
import { ApiService } from './api.service';
import { SessionService } from './session.service';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  readonly user$ = new BehaviorSubject<User | null>(null);

  constructor(private readonly api: ApiService) {
    inject(SessionService)
      .accessToken$.pipe(
        filter((token) => token != null),
        switchMap(() => this.getSignedInUserDetails()),
      )
      .subscribe();
  }

  public getSignedInUserDetails(): Observable<User> {
    return this.api
      .get(`v1/user/detail`, {}, environment.zuul)
      .pipe(tap((user: User) => this.user$.next(user)));
  }

  public setUserActive(): Observable<void> {
    return this.api.put(`v1/user/activate`, {});
  }
}
